export const getEnv = (key) => {
  const windowEnvs = window.env || {};
  return key in windowEnvs ? windowEnvs[key] : process.env[key];
};
